import { requestJson } from './http'

export type AutogiroMandateStatus = 'pending' | 'approved' | 'failed' | 'removed'

export interface PlannedDebitAccount {
  accountNumber: string
  mandateStatus: AutogiroMandateStatus | null
}

export interface MandateAwaitingSignature {
  accountNumber: string
  signingLink: string
}

export interface CustomerAutogiro {
  plannedDebitAccount: PlannedDebitAccount | null
  mandateAwaitingSignature: MandateAwaitingSignature | null
}

export const fetchCustomerAutogiro = (userId: string): Promise<CustomerAutogiro> =>
  requestJson<CustomerAutogiro>(`/borgo/distributor/customers/${encodeURIComponent(userId)}/autogiro`, 'GET')
